module.exports = __webpack_public_path__ + "static/media/raqeeb_chang.a305b57c.png";